module.exports = __webpack_public_path__ + "static/media/PHOTO-2023-09-06-13-00-19(2).3145584b.jpg";